import { Button } from '@mui/material';
import { FC } from 'react';

type CreateRefundBottomToolbarProps = {
  handleClearForm?: () => void;
};

export const CreateRefundBottomToolbar: FC<CreateRefundBottomToolbarProps> = ({ handleClearForm }) => {
  return (
    <div className="flex justify-end gap-x-2 border-t border-t-[#DFEBF1] bg-white p-4">
      <Button
        variant="text"
        color="primary"
        size="large"
        disableElevation
        className="rounded-lg text-sm font-medium disabled:bg-[#EAEEFC] disabled:text-[#A3C8FF]"
        onClick={handleClearForm}
      >
        Clear form
      </Button>

      <Button
        variant="contained"
        color="primary"
        size="medium"
        disableElevation
        className="rounded-lg text-sm font-medium disabled:bg-[#EAEEFC] disabled:text-[#A3C8FF]"
        type="submit"
      >
        Issue Refund
      </Button>
    </div>
  );
};
